import type { FC, ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

// Components:
import { MobilePopupBottom } from '@lt/components';

interface ISortingModal {
  children: ReactNode;
  visible: boolean;
  onBackgroundClick: () => void;
}

export const SortingModal: FC<ISortingModal> = ({
  children,
  visible,
  onBackgroundClick,
}) => (
  <StyledMobilePopup
    visible={visible}
    onClick={onBackgroundClick}
    options={{ showHandlebar: true }}
  >
    {children}
  </StyledMobilePopup>
);

const StyledMobilePopup = styled(MobilePopupBottom)`
  padding-bottom: 16px;
`;
